/**
 * @generated SignedSource<<df9e8ec5900ce02eed00df68136c87f1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type helpObjectArticle_HelpObjectStoreArticle$data = {
  readonly description: string | null | undefined;
  readonly displayLink: string | null | undefined;
  readonly entityKey: string | null | undefined;
  readonly title: string | null | undefined;
  readonly " $fragmentType": "helpObjectArticle_HelpObjectStoreArticle";
};
export type helpObjectArticle_HelpObjectStoreArticle$key = {
  readonly " $data"?: helpObjectArticle_HelpObjectStoreArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpObjectArticle_HelpObjectStoreArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "helpObjectArticle_HelpObjectStoreArticle",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "displayLink"
    },
    {
      "kind": "ScalarField",
      "name": "entityKey"
    }
  ],
  "type": "HelpObjectStoreArticle"
};

(node as any).hash = "0756127ce7f1720f66c3f5094e6a880d";

export default node;
